/**
 * Shared class recipes for form controls that aren't built on the base Field component
 * (tag / multi-select / stepper / timezone …). Mirrors components/Field exactly.
 */
export const FOCUS_RING =
  '0_4px_4px_-3px_rgba(0,0,0,0.1),0_0_0_1px_rgb(var(--lc-brand)),0_0_0_4px_rgb(var(--lc-brand)/0.14)'

export const INPUT_CLASS =
  'h-8 w-full rounded-[8px] bg-surface px-2 text-[14px] leading-[1.4] tracking-[-0.2px] text-ink shadow-input outline-none ' +
  'transition-shadow duration-[160ms] ease-out-strong placeholder:text-ink-4 ' +
  `focus:shadow-[${FOCUS_RING}] disabled:cursor-not-allowed disabled:opacity-60`

export const INPUT_ERROR_CLASS = 'shadow-[0_4px_4px_-3px_rgba(0,0,0,0.1),0_0_0_1px_#D33]'

export const INPUT_OPEN_CLASS = `shadow-[${FOCUS_RING}]`

export const LABEL_CLASS =
  'mb-1.5 flex text-[12px] font-medium leading-[1.4] tracking-[-0.2px] text-ink-3'

export const NOTE_CLASS = 'mt-1.5 text-[12px] leading-[1.4] tracking-[-0.2px] text-ink-4'

export const POP_CLASS = 'rounded-[12px] bg-surface p-1.5 shadow-pop dark:bg-surface-2'

export const OPTION_CLASS =
  'flex w-full cursor-pointer items-center gap-2.5 rounded-[8px] px-2.5 py-2 text-left text-[14px] font-medium leading-[1.2] tracking-[-0.2px] text-ink-2 ' +
  'transition-colors duration-[120ms] hover:bg-surface-2 hover:text-ink dark:hover:bg-surface-3'

export const CHIP_CLASS =
  'inline-flex h-7 items-center gap-1 rounded-full bg-canvas pl-2.5 pr-1 text-[12px] font-medium tracking-[-0.2px] text-ink-2 dark:bg-surface-3'

export const CHIP_REMOVE_CLASS =
  'inline-flex size-4 items-center justify-center rounded-full text-ink-4 outline-none transition-colors duration-[120ms] hover:bg-surface hover:text-[#D33] focus-visible:ring-2 focus-visible:ring-brand/40 disabled:cursor-not-allowed disabled:opacity-50'
